/** disabling for now until we can share this as a public signature */
export const cipher = (s: string) => s;
// export const cipher = (s: string): string =>
//   s
//     .split('')
//     .map(c => String.fromCharCode(c.charCodeAt(0) + 1))
//     .join('');

export const decipher = (s: string) => s;

// export const decipher = (s: string): string =>
//   s
//     .split('')
//     .map(c => String.fromCharCode(c.charCodeAt(0) - 1))
//     .join('');

const getToken = (): {
  token: string;
  expires: Date;
} | null => {
  const cached = sessionStorage.getItem('token');
  if (cached === null) {
    return cached;
  }
  const deciphered = decipher(cached);
  const [token, expires] = deciphered.split('|');
  return {
    token,
    expires: new Date(expires),
  };
};

const setToken = (token: string, expires: string) => {
  const res = cipher(`${token}|${expires}`);
  sessionStorage.setItem('token', res);
};

const remove = () => sessionStorage.removeItem('token');

const jwt = {
  get: getToken,
  set: setToken,
  remove,
};

export type Jwt = typeof jwt;

export default jwt;
